/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Image } from "antd";

interface HeaderProps {
  // companyId: string;
  // estimateId: string;
  showSignModal: () => void;
  setShowRevisionModal: () => void;
  proposalDocumentData?: any;
}

export default function DocumentHeader({
  showSignModal,
  setShowRevisionModal,
  proposalDocumentData,
}: HeaderProps) {
  return (
    <div className="estimateHeader">
      <div className="headerLeft">
        <div className="estimateHeaderText no-padding">
          <div className="estimateTitle">
            <div
              className="estimateTitleText"
              style={{ display: "flex", alignItems: "center", gap: "6px" }}
            >
              Potential Deal Name:<b>First deal</b>
            </div>
          </div>
          <div className="description">
            <Image src="/images/estimate/home-icon.svg" preview={false} />
            Proposal document
          </div>
        </div>
      </div>
      {!proposalDocumentData?.is_accepted && (
        <div className="two_btns">
          <Button
            size="large"
            className="outlined-btn"
            onClick={setShowRevisionModal}
          >
            Ask for revision
          </Button>
          <Button onClick={showSignModal} className="mint-btn">
            Sign & accept
          </Button>
        </div>
      )}
    </div>
  );
}
